import React, { Fragment, useEffect, useState, useRef } from "react";
import { Container, Form, Dropdown, OverlayTrigger, Popover } from "react-bootstrap";
import "./TaskAssignMembers.scss";
import removeAttachment from "../../assets/icons/Icon-Remove-Attachment-Blue-10px.svg";
import { FluentAvatar } from "../FluentUI/Fluent-Avatar";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { unavailableReason } from "./TaskAssignMemberHelper";

const TaskAssignMembers = ({
  assignedMembers,
  assignedOwner,
  filteredAssignedMembers,
  addMembersInForm,
  removeMembersInForm,
  isDisabled,
  permissionTaskMembers = [],
  task,
  currUserId,
  ownerGroup = null,
  CanChangeApprover,
  CanChangeEditor,
  CanChangeViewer,
  CanChangeOwner
}) => {
  const [membersList, setMembersList] = useState([]);
  const [ownerMember, setOwnerMember] = useState(assignedOwner);
  const [ownerMembers, setOwnerMembers] = useState(assignedOwner);
  const [editorMembers, setEditorMembers] = useState([]);
  const [viewerMembers, setViewerMembers] = useState([]);
  const [approverMembers, setApproverMembers] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [filteredOwnerSuggestions, setFilteredOwnerSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState({ owner: false, editor: false, viewer: false, approver: false });
  const [filteredMembersName, setFilterMembersName] = useState([]);
  const [inputField, setInputField] = useState({ owner:"", editor: "", viewer: "", approver: "" });
  const [errorMessage, setErrorMessage] = useState({ owner:"", editor: "", viewer: "", approver: "" });
  const assignMemberOptions = ["Owner","Editor", "Viewer", "Approver"];
  const node = useRef();
  let ownerLabelClassName = "taskUserListTitle";

  useEffect(() => {
    if (ownerGroup && ownerGroup.GroupMembers) {
      ownerGroup.Members = ownerGroup.GroupMembers;
    }
  }, [ownerGroup]);

  useEffect(() => { 

    let editorArray = getAssignedMembers("editor");
    let viewerArray = getAssignedMembers("viewer");
    let approverArray = getAssignedMembers("approver");
    let removeConcatMembers = getUpdatedFilterMembersName([...editorArray, ...viewerArray, ...approverArray]);
    setMembersList([...assignedMembers]);
    setOwnerMember(assignedOwner);
    setFilterMembersName([...removeConcatMembers]);
    setFilteredSuggestions([...removeConcatMembers]);
    setEditorMembers([...editorArray]);
    setViewerMembers([...viewerArray]);
    setApproverMembers([...approverArray]);
    setOwnerMembers(assignedOwner);
    setFilteredOwnerSuggestions(filteredAssignedMembers);
  }, [assignedMembers, filteredAssignedMembers]);

  const updateFilterMembersName = (permission, filterName) => {
    let newFilterNames = [];
    let resultFilterMembersName = [];

    if (permission === "editor") {
      newFilterNames = editorMembers.find(member => member.Name === filterName);
    } else if (permission === "viewer") {
      newFilterNames = viewerMembers.find(member => member.Name === filterName);
    } else if (permission === "approver") {
      newFilterNames = approverMembers.find(member => member.Name === filterName);
    }

    if (newFilterNames) {
      resultFilterMembersName = [...filteredMembersName];
      resultFilterMembersName.push(filterName);
    } else {
      resultFilterMembersName = [...filteredMembersName.filter(name => filterName !== name)];
    }

    return resultFilterMembersName;
  };

  const getAssignedMembers = permission => {
      let newPermissionTaskMembers = [...permissionTaskMembers];
      let newPermissionMember = [];
      let availableMembers = [];

      if (permission === "editor") {
        newPermissionMember = [...newPermissionTaskMembers.filter(p => p.canEdit === true)];
      } else if (permission === "viewer") {
        newPermissionMember = [...newPermissionTaskMembers.filter(p => p.canView === true)];
      } else if (permission === "approver") {
        newPermissionMember = [...newPermissionTaskMembers.filter(p => p.canApprove === true)];
      } else if (permission === "owner") {
        newPermissionMember = [...newPermissionTaskMembers.filter(p => p.isOwner === true)];
      }
      if (newPermissionMember.length > 0) {
        availableMembers = assignedMembers.filter(member => {
          return newPermissionMember.some(p => {
            return p.Id === member.Id && p.IsGroup == (member.IsGroup ?? false);
          });
        });

        // Archived/moved assignees are excluded from the assignable pool, so they
        // never match above. Fall back to the task member itself so the assignment
        // still renders (greyed) instead of silently disappearing (TAD-5898).
        const orphaned = newPermissionMember
          .filter(p =>
            p.Archived && p.Member &&
            !availableMembers.some(member => member.Id === p.Id && (member.IsGroup ?? false) === p.IsGroup)
          )
          .map(p => p.Member);
        availableMembers = [...availableMembers, ...orphaned];
      }
      return availableMembers;
    };

  const getUpdatedFilterMembersName = (concatMembers) => {
    let updateFilterMembersName = [];
    let newFilteredNames = [];
    if (concatMembers) {
      concatMembers.map((member) => newFilteredNames.push(member.Name));
      updateFilterMembersName = filteredAssignedMembers?.filter(
        (name) => !newFilteredNames.includes(name)
      );
    }
    return updateFilterMembersName;
  };

  const assignMembers = permission => {
    let newMembers = [];
    
    if (permission === "editor") {
      newMembers = [...editorMembers];
    } else if (permission === "viewer") {
      newMembers = [...viewerMembers];
    } else if (permission === "approver") {
      newMembers = [...approverMembers];
    } else if (permission === "owner") {
      newMembers = [ownerMembers];
    }
    return newMembers;
  };

  const updateMembers = (permission, newMembers) => {
    if (permission === "editor") {
      setEditorMembers(newMembers);
    } else if (permission === "viewer") {
      setViewerMembers(newMembers);
    } else if (permission === "approver") {
      setApproverMembers(newMembers);
    } else if (permission === "owner") {
      setOwnerMember(newMembers);
      setOwnerMembers(newMembers);
    }
  };

  const removeDuplicates = (originalArray, prop) => {
    let newArray = [];
    let lookupObject = {};
    for (let i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (let i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };

  const disablePill = (permission) => {
    if(isDisabled) return true;
    if (permission === "editor") {
      return !CanChangeEditor;
    } else if (permission === "viewer") {
      return !CanChangeViewer;
    } else if (permission === "approver") {
      return !CanChangeApprover;
    } else if (permission === "owner") {
      return !CanChangeOwner;
    }
    return true;
  };


  const showUserMembers = (permission) => {
    let currMembers = assignMembers(permission);
      return currMembers.map(user => {
        return (
          <div key={user.Id}>
            <div className={`small d-flex d-flex-row pill-fill-container ${disablePill(permission) ? "pills-gray-background" : "pills-blue-background"} ${user.IsGroup ? "is-a-group" : ""} ${user?.Archived ? "pill-archived" : ""}`} data-testid={user?.Name} title={user?.Archived ? unavailableReason(user) : undefined}>
              {user.IsGroup && !user?.Archived ?
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="bottom"
                  delay={{ show: 150, hide: 150 }}
                  overlay={
                    <Popover id="description-popover" className=" assignMemberContainer custom-popover-group">
                      <Popover.Title>Group Members</Popover.Title>
                      <Popover.Content>
                        {(user?.Members || []).map(member => {
                          return (
                            <div key={member.User.Id} className="d-flex m-1">
                              <FluentProvider theme={webLightTheme}><FluentAvatar size={24} name={member?.User?.Name} className="task-member-default"/></FluentProvider>
                              <span className={`w-8 pl-2 pr-1 ${ownerLabelClassName} pull-left`}>
                                {member?.User?.Name}
                              </span>
                            </div>
                          );
                        })}
                      </Popover.Content>
                    </Popover>
                  }>
                  <div className="d-flex">
                  <FluentAvatar size={32} name={user.Name} className="task-member-default isGroup"/>
                    <span className={`w-8 pl-2 pr-1 ${ownerLabelClassName} pull-left`}>
                      {user.Name.length > 20 ? `${user?.Name?.slice(0, 20)}...` : user?.Name}
                    </span>
                  </div>
                </OverlayTrigger>
                : user.IsGroup ?
                // Archived groups carry no roster — the "Group Members" popover
                // would be blank; the container title carries the reason instead
                // (QA feedback, TAD-5898).
                <div className="d-flex">
                  <FluentAvatar size={32} name={user.Name} className="task-member-default isGroup"/>
                  <span className={`w-8 pl-2 pr-1 ${ownerLabelClassName} pull-left`}>
                    {user.Name.length > 20 ? `${user?.Name?.slice(0, 20)}...` : user?.Name}
                  </span>
                </div>
                :
                <>
                  <FluentAvatar size={32} name={user?.Name} className={`${permission === "owner" ? "task-member-user": "task-member-default"}`}/>
                  <span className={`w-8 pl-2 pr-1 ${ownerLabelClassName} pull-left`}>
                    {user?.Name?.length > 20 ? `${user?.Name?.slice(0, 20)}...` : user?.Name}
                  </span>
                </>}
              <img
                src={removeAttachment}
                className={`${disablePill(permission) ? "cross-button-disabled" : "pointer"} cross-button`}
                alt="cross-button"
                disabled={permission === "owner"}
                onClick={() => {
                  if (!isDisabled && !disablePill(permission) && permission != "owner") deleteUserMembers(permission, user);
                }}
              />
            </div>
          </div>
        );
      });
  };

  const deleteUserMembers = (permission, removedUser) => {
    let updatedMembers = assignMembers(permission);
    let removedMember = updatedMembers.find(member => member.Id === removedUser.Id && member.IsGroup === removedUser.IsGroup);
    
    setFilterMembersName([...updateFilterMembersName(permission, removedMember.Name)]);
    setFilteredSuggestions([...updateFilterMembersName(permission, removedMember.Name)]);
    setFilteredOwnerSuggestions(filteredAssignedMembers);
    
    updatedMembers = updatedMembers.filter(member => !(member.Id === removedUser.Id && member.IsGroup === removedUser.IsGroup));
    
    removeMembersInForm(permission, removedUser.Id, removedUser.IsGroup);
    updateMembers(permission, updatedMembers);
  };

  const onChangeMemberInput = (e, permission) => {
    let currInput = e.currentTarget.value;
    let availableSuggestions = filteredMembersName.filter(
      suggestion => suggestion.toLowerCase().indexOf(currInput.toLowerCase()) > -1
    );
    if (currInput) {
      setShowSuggestions({ ...showSuggestions, [permission]: true });
    } else {
      setShowSuggestions({ ...showSuggestions, [permission]: false });
    }
    if(permission !== "owner"){
      setFilteredSuggestions(availableSuggestions);
    }
    else{
      let availableOwnerSuggestions = filteredAssignedMembers.filter(
        suggestion => suggestion.toLowerCase().indexOf(currInput.toLowerCase()) > -1
      );
      setFilteredOwnerSuggestions(availableOwnerSuggestions);
    }
    setErrorMessage({ ...errorMessage, [permission]: "" });
    setInputField({ ...inputField, [permission]: e.currentTarget.value });
  };

  const onKeyDownAddMembers = (e, permission) => {
    if (e.keyCode === 13) {
      setActiveSuggestion(0);
      setShowSuggestions({ ...showSuggestions, [permission]: false });
      setInputField({ ...inputField, [permission]: filteredSuggestions[activeSuggestion] });
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const onClickMemberSuggestion = (suggestion, permission) => {
    let updatedMembers = assignMembers(permission);
    // New members filter now by words due to inner text remove last space in names automatically
    let newMember = membersList.filter(
      member => member.Name.split(" ").join("") === suggestion.split(" ").join("")
    );

    const addId = newMember[0]?.Id;
    const checkEditorExists = editorMembers.some(member => member.Name === newMember[0]?.Name);
    const checkViewerExists = viewerMembers.some(member => member.Name === newMember[0]?.Name);
    const checkApproverExists = approverMembers.some(member => member.Name === newMember[0]?.Name);

    if ((checkEditorExists || checkViewerExists || checkApproverExists) && permission !== "owner") {
      setErrorMessage({
        ...errorMessage,
        [permission]: `${newMember[0].Name.length > 20 ? `${newMember[0].Name.slice(0, 20)}...` : newMember[0]?.Name}
        already exists, please try a different member`
      });
    } else {
      if(newMember[0]?.IsGroup){
        addMembersInForm(permission, addId,true);
      }
      else{
        addMembersInForm(permission, addId,false);
      }
      updatedMembers = [...updatedMembers, ...newMember];
      if (permission === "owner") { // remove for multiple owners
        updateMembers(permission, newMember[0]);
      }
      else{
        updateMembers(permission, updatedMembers);
      }
    }
    setActiveSuggestion(0);

    if(permission !== "owner"){
      setFilteredSuggestions([...updateFilterMembersName(permission, newMember[0]?.Name)]);
      setFilterMembersName([...updateFilterMembersName(permission, newMember[0]?.Name)]);
    }
    else{
      setFilteredOwnerSuggestions(filteredAssignedMembers);
    }
    
    setShowSuggestions({ ...showSuggestions, [permission]: false });
    setInputField({ ...inputField, [permission]: "" });
  };

  const handleLostFocus = (permission, event) => {
    setShowSuggestions({ ...showSuggestions, [permission]: false });
    setInputField({ ...inputField, [permission]: "" });
    setFilteredSuggestions(filteredMembersName);
    setFilteredOwnerSuggestions(filteredAssignedMembers);
    event.preventDefault();
  };

  const handleOnFocus = (permission, event) => {
    setShowSuggestions({ ...showSuggestions, [permission]: true });
    setInputField({ ...inputField, [permission]: "" });
    event.preventDefault();
  };

  const UsersFromProjectAndDepartment = (option) => {
    let membersFromProject = filteredSuggestions.filter((suggestion) => {
      let member = membersList?.find((member) => member.Name === suggestion);
      return member && member.IsProjectMember;
    });

    let membersFromDepartment = filteredSuggestions.filter((suggestion) => {
      let member = membersList?.find((member) => member.Name === suggestion);
      return member && !member.IsProjectMember;
    });
    //To be removed once we have groups as owners
    if(option === "owner"){
      membersFromProject = filteredOwnerSuggestions.filter((suggestion) => {
        let member = membersList?.find((member) => member.Name === suggestion && ownerMembers?.Name !== suggestion);
        return member && member.IsProjectMember  && !member.IsGroup;
      });
  
      membersFromDepartment = filteredOwnerSuggestions.filter((suggestion) => {
        let member = membersList?.find((member) => member.Name === suggestion && ownerMembers?.Name !== suggestion);
        return member && !member.IsProjectMember && !member.IsGroup;
      });
    }
    //////////////////////////////
    return (
      <>
        {membersFromProject?.length > 0 && (
          <>
            <div className="dropdown-section-header p-2">
              Users from the Selected Project
            </div>
            {membersFromProject.map((suggestion, index) => {
              let Member = membersList?.find(
                (member) => member.Name == suggestion
              );
              return (
                <Fragment key={suggestion}>
                  <Dropdown.Item
                    onKeyDown={(e) => onKeyDownAddMembers(e)}
                    className="dropdown-row"
                    key={1}
                    value={1}
                    name={suggestion}
                    onClick={(e) => onClickMemberSuggestion(suggestion, option)}
                    onMouseDown={(e) => {
                      e.preventDefault();
                    }} // This code is added to prevent onBlur to trigger before onClick
                  >
                    <span className="dropdown-row-text">
                      <FluentAvatar
                        size={24}
                        name={suggestion}
                        className={`task-member-default ${
                          Member?.IsGroup ? "isGroup" : ""
                        }`}
                      />{" "}
                      {suggestion}
                    </span>
                  </Dropdown.Item>
                </Fragment>
              );
            })}
          </>
        )}
        {membersFromDepartment?.length > 0 && (
          <>
            <div className="dropdown-section-header p-2">
              Users from your Department
            </div>
            {membersFromDepartment.map((suggestion, index) => {
              let Member = membersList?.find(
                (member) => member.Name == suggestion
              );
              return (
                <Fragment key={suggestion}>
                  <Dropdown.Item
                    onKeyDown={(e) => onKeyDownAddMembers(e)}
                    className="dropdown-row"
                    key={1}
                    value={1}
                    name={suggestion}
                    onClick={(e) => onClickMemberSuggestion(suggestion, option)}
                    onMouseDown={(e) => {
                      e.preventDefault();
                    }} // This code is added to prevent onBlur to trigger before onClick
                  >
                    <span className="dropdown-row-text">
                      <FluentAvatar
                        size={24}
                        name={suggestion}
                        className={`task-member-default ${
                          Member?.IsGroup ? "isGroup" : ""
                        }`}
                      />{" "}
                      {suggestion}
                    </span>
                  </Dropdown.Item>
                </Fragment>
              );
            })}
          </>
        )}
      </>
    );
  };

  const suggestionsListComponent = (option) => (
    <Fragment>
      <div className="dropdown-main-top-level" ref={node}>
        <Dropdown className="dropdown-main" show={showSuggestions[option]}>
          {
            <Dropdown.Toggle
              tabIndex="0"
              id="dropdown-toggle"
              className={`pill-wapper dropdown-button assignMembersWrapper ${
                disablePill(option)
                  ? "dropdown-members dropdown-button-disabled"
                  : "dropdown-members"
              } dropdown-input`}
              as="div"
            >
              {showUserMembers(option)}
              <input
                type="text"
                value={inputField[option]}
                onChange={(e) => onChangeMemberInput(e, option)}
                onKeyDown={(e) => {
                  onKeyDownAddMembers(e, option);
                  e.key === "Enter" && e.preventDefault();
                }}
                onBlur={(e) => {
                  handleLostFocus(option, e);
                }}
                onClick={(e) => {
                  handleOnFocus(option, e);
                }}
                placeholder="Enter new member"
                disabled={disablePill(option)}
              />
            </Dropdown.Toggle>
          }
          <Dropdown.Menu className={`dropdown-main-menu`} as="div">
            {UsersFromProjectAndDepartment(option)}          
          </Dropdown.Menu>
        </Dropdown>
        {errorMessage[option] !== "" && (
          <Form.Label>
            <div type="invalid" className="error-message-assign">
              {errorMessage[option]}
            </div>
          </Form.Label>
        )}
      </div>
    </Fragment>
  );

  return (
    <div>
      <Container className="form-custom-control assignMemberContainer mt-3">
        {/* Code needed for when we have seperate owner and creator */}
        {/* <Form.Group className="mt-3">
          <div className={`loginInput mb-2`}>Owner</div>
          {ownerGroup != null
            ?           
            <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="bottom-start"
            delay={{ show: 150, hide: 150 }}
            overlay={
              <Popover id="description-popover" className=" assignMemberContainer custom-popover-group">
                <Popover.Title>Group Members</Popover.Title>
                <Popover.Content>
                  {ownerGroup?.Members?.map(member => {
                    return (
                      <div key={member.User.Id} className="d-flex m-1"> 
                        <FluentProvider theme={webLightTheme}>
                          <FluentAvatar size={24} initials={member?.User?.Initials} className={`${context?.userID == member.UserId ? "task-member-user" : "task-member-default"}`}/>
                          </FluentProvider>
                        <span className={`w-8 pl-2 pr-1 ${ownerLabelClassName} pull-left`}>
                          {member?.User?.Name}
                        </span>
                      </div>
                    );
                  })}
                </Popover.Content>
              </Popover>
            }>
              <div className="d-flex">
                {ownerGroup?.Initials && (
                    <FluentAvatar size={32} initials={ownerGroup.Initials} className="task-member-default isGroup"/>
                )}
                <span style={{ height: "2.2em" }} className={`w-8 pl-2 pr-1 pt-1 ${ownerLabelClassName} pull-left`}>
                  {ownerGroup?.Name ? ownerGroup.Name : "Select a Project before assigning members"}
                </span>
              </div>
            </OverlayTrigger>
            :
            <div className="d-flex d-flex-row">
              {ownerMember?.Initials && (
                <FluentAvatar size={32} initials={ownerMember.Initials} className="task-member-user"/>
              )}
              <span style={{ height: "2.2em" }} className={`w-8 pl-2 pr-1 pt-1 ${ownerLabelClassName} pull-left`}>
                {ownerMember?.Name ? ownerMember.Name : "Select a Project before assigning members"}
              </span>
            </div>
          }
        </Form.Group> */}
        {/* {ownerGroup!= null ?         
        <Form.Group className="mt-3">
          <div className={`loginInput mb-2`}>Creator</div> 
            <div className="d-flex d-flex-row">           
              {ownerMember?.Initials && (
                <FluentAvatar size={32} initials={ownerMember.Initials} className="task-member-user"/>
              )}
              <span style={{ height: "2.2em" }} className={`w-8 pl-2 pr-1 pt-1 ${ownerLabelClassName} pull-left`}>
                {ownerMember?.Name ? ownerMember.Name : "Select a Project before assigning members"}
              </span>
            </div>   
          </Form.Group>
           :<div></div>
        } */}
        {assignMemberOptions.map(option => (
          <Form.Group key={option.toLowerCase()}>
            <Form.Label className={`loginInput`}>{option}</Form.Label>
            {suggestionsListComponent(option.toLowerCase())}
          </Form.Group>
        ))}
      </Container>
    </div>
  );
};

export default TaskAssignMembers;
